/** The small mono "LOCKED" eyebrow DESIGN.md specifies for locked cells/sections. */
export function LockBadge({ className = '' }: { className?: string }) {
  return <span className={`eyebrow text-signal ${className}`}>Locked</span>;
}
